import { Messages } from '../../localization';

export const noComparisonRowSubtitle = () => {
  return Messages.metricsNoComparisonRowSubtitle;
};
